export default "__VITE_ASSET__tlsBgMXB__"